<template>
  <v-container fluid>
    <div class="mb-4">
      <v-row>
        <!-- <v-col cols="12" md="3" sm="6">
          <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
            :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on" dense outlined hide-details></v-text-field>
            </template>
<v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
  @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
</v-menu>
</v-col>
<v-col cols="12" md="3" sm="6">
  <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
    :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
    <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
                v-on="on" dense outlined hide-details></v-text-field>
            </template>
    <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
      @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
  </v-menu>
</v-col> -->
        <v-col cols="12" md="3" sm="6">
          <v-menu ref="month_menu" v-model="month_menu" :close-on-content-click="false"
            :return-value.sync="queryForm.month" transition="scale-transition" min-width="auto" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="queryForm.month" label="月份" append-icon="mdi-calendar" readonly v-bind="attrs"
                v-on="on" dense outlined hide-details></v-text-field>
            </template>
            <v-date-picker v-model="queryForm.month" type="month" no-title value="YYYY-mm" scrollable locale="zh-cn"
              @input="() => { $refs.month_menu.save(queryForm.month); month_menu = false; }"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="3" sm="6">
          <v-select v-model="postofficeid" :items="postoffices" label="地市局" no-data-text="无" dense outlined hide-details
            :menu-props="{ bottom: true, offsetY: true }"></v-select>
        </v-col>
        <v-col cols="12" md="3" sm="6">
          <a-space>
            <v-btn @click="getdata('')" color="primary" dark tile>
              <v-icon small>mdi-magnify</v-icon>查询
            </v-btn>
            <v-btn @click="getdata('download')" color="indigo" dark tile>
              <v-icon small>mdi-download</v-icon>下载结算汇总数据
            </v-btn>
          </a-space>
        </v-col>
      </v-row>
    </div>
    <v-card>
      <v-data-table dense :headers="headers" :items="tableData" :items-per-page="tableData.length" no-data-text="无数据"
        hide-default-footer disable-sort fixed-header :height="height">
        <template v-slot:item.f_diff="{ item }">
          <span :class="{
            'error--text': item.diff < 0,
            'success--text': item.diff > 0,
          }">
            {{ item.f_diff }}
          </span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";

export default {
  name: "SettleSummary",
  data() {
    return {
      queryForm: {
        // start_day: this.$moment().startOf("month").format("YYYY-MM-DD"),
        // end_day: this.$moment().format("YYYY-MM-DD"),
        month: this.$moment().format("YYYY-MM"),
      },
      postofficeid: "",
      postoffices: [],
      headers: [
        { text: "序号", value: "index", width: 80, align: "center" },
        { text: "地市局", value: "postoffice", width: 140, align: "center" },
        { text: "线路", value: "postline", width: 200, align: "center" },
        { text: "单程/往返", value: "transport_kind", width: 100, align: "center" },
        { text: "车型", value: "vehicle_type", width: 130, align: "center" },
        { text: "总班次", value: "count", width: 110, align: "center" },
        { text: "合同运费(元)", value: "f_freight", width: 160, align: "center" },
        { text: "油价联动后运费(元)", value: "f_oilfreight", width: 160, align: "center" },
        { text: "调整差异(元)", value: "f_diff", width: 160, align: "center" },
        { text: "考核(元)", value: "check_amount", width: 140, align: "center" },
        { text: "结算金额(元)", value: "f_real_oilfreight", width: 160, align: "center" },
      ],
      list: [],
      height: 600,
      start_day_menu: false,
      end_day_menu: false,
      month_menu: false,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    tableData() {
      return this.list.map((it, idx) => {
        let diff = this.$d(it.oilfreight).minus(it.freight).toString();
        return {
          ...it,
          _id: it._id || `${it.postroute || "row"}_${idx}`,
          index: idx + 1,
          postoffice_name: it.postoffice_name || (this.postoffices.find(p => p.value === this.postofficeid) || {}).label || "",
          f_freight: this.$formatMoney(it.freight, 2, ''),
          f_oilfreight: this.$formatMoney(it.oilfreight, 2, ''),
          f_real_oilfreight: this.$formatMoney(it.real_oilfreight, 2, ''),
          diff: Number(diff),
          f_diff: this.$formatMoney(diff, 2, ''),
        };
      });
    },
  },
  components: {},
  watch: {},
  mounted() {
    this.height = window.innerHeight - 150;
    window.onresize = () => {
      this.height = window.innerHeight - 150;
    };
    this.list = [];
    this.queryForm = {
      // start_day: this.$moment().startOf("month").format("YYYY-MM-DD"),
      // end_day: this.$moment().format("YYYY-MM-DD"),
      month: this.$moment().format("YYYY-MM"),
    };
    this.getdata();
  },
  methods: {
    getdata(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/settlebill/list", { ...this.queryForm, postofficeid: this.postofficeid, action }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (action === "download" && res.data.url) {
            return this.$download(res.data.url, res.data.name);
          }
          this.postoffices = res.data.postoffices;
          this.postofficeid = res.data.postofficeid;
          this.list = res.data.list;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        this.$alert(err.message || "请求失败");
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-table-tbody>tr>td {
  padding: 4px 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}
</style>
